import React from 'react'
import PropTypes from 'prop-types'

import { Loader } from 'semantic-ui-react'

import InlineCss from 'react-inline-css'

const styles = `
.ui.active.loader{
  top: 30%;
}`

const PictureLoader = ({ pending }) =>
  pending ? (
    <div>
      <InlineCss stylesheet={styles} />
      <Loader size="big" active />
    </div>
  ) : null

PictureLoader.propTypes = {
  pending: PropTypes.bool.isRequired,
}

export default PictureLoader
